module.exports = __webpack_public_path__ + "img/23CF.553536dc.svg";